// The sign uses the PDF standard fonts (Helvetica, Times), so it needs no font
// download and prints the same everywhere. They cover WinAnsi: Latin letters
// including æ ø å ä ö ü é, and common punctuation. Anything else (emoji,
// other scripts) is removed, and the editor says so.

const WIN_ANSI_EXTRA = "€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ";

function isWinAnsi(codePoint: number): boolean {
  return (
    (codePoint >= 0x20 && codePoint <= 0x7e) ||
    (codePoint >= 0xa0 && codePoint <= 0xff) ||
    WIN_ANSI_EXTRA.indexOf(String.fromCodePoint(codePoint)) !== -1
  );
}

export interface SanitizedText {
  text: string;
  removed: boolean;
}

export function sanitizePrintableText(input: string): SanitizedText {
  const normalized = input.normalize("NFC");
  let text = "";
  let removed = false;

  for (const character of Array.from(normalized)) {
    const codePoint = character.codePointAt(0) ?? 0;
    if (/\s/.test(character)) {
      text += " ";
    } else if (isWinAnsi(codePoint)) {
      text += character;
    } else {
      removed = true;
    }
  }

  return { text: text.replace(/ {2,}/g, " ").trim(), removed };
}
